<div class="card">
  <div class="card-body pt-0 pb-0">
    <div class="d-md-flex align-items-center  px-3 mb-2" style=" background-color: whitesmoke;">
      <div class="d-flex align-items-center p-2">
        <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{Title}}</h5>
      </div>
      <div class="mt-3 mt-md-0 d-md-flex align-items-center  " *ngIf="environment.ClientiAddOn['referentiFromPersone']">
        <div class="input-group flex-grow-1" *ngIf="environment.ClientiAddOn['referentiFromPersone'] ">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: transparent;">
              {{'cliente.persona' | translate}}
            </span>
          </div>
          <ng-multiselect-dropdown [settings]="{singleSelection: true, singleOutput:true, textField:'fullName'}" [placeholder]="'Seleziona'" [data]="persone"
            [(ngModel)]="persona"></ng-multiselect-dropdown>
        </div>
        <div class="input-group flex-grow-1" *ngIf="environment.ClientiAddOn['relazioniReferenti'] ">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: transparent;">
              {{'cliente.relation' | translate}}
            </span>
          </div>
          <ng-multiselect-dropdown [settings]="{singleSelection: true, singleOutput: true, textField:'label'}" [placeholder]="'Seleziona'" [data]="relations"
            [(ngModel)]="relation"></ng-multiselect-dropdown>
        </div>
      </div>
      <div class="ml-auto mt-3 mt-md-0">
        <button type="button" class="btn  py-2" (click)='add()'><i class="fas fa-plus  font-14 mr-1 text-info"></i>
          <span class="ml-1 text-info font-weight-bold">Aggiungi</span>
        </button>
        <button *ngIf="environment.ClientiAddOn['importReferenti']" class="btn btn-white rounded-pill py-2" (click)='Import()'><i
          class="fas fa-upload  font-14 mr-1 text-info"></i>
          <span class="ml-1 text-info ">Importa</span>
        </button>
        <button *ngIf="SelectedRef()?.length>0 && environment.ClientiAddOn['InvioCredReferenti']" class="btn btn-white rounded-pill py-2" (click)='InviaCred()'><i
          class="fas fa-upload  font-14 mr-1 text-info"></i>
          <span class="ml-1 text-info ">Invia Credenziali</span>
        </button>
        <button *ngIf="environment.Modules['FabbisognoFormativo']" class="btn btn-white rounded-pill py-2" (click)='AggiungiFabbisogni()'>
          <i class="fas fa-hands-helping font-14 mr-1 text-info"></i>
          <span class="ml-1 text-info ">Genera {{'Training' | translate}} </span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3">
          <div class="input-group flex-grow-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style="background-color: transparent;">
                <i class="fas fa-search"></i>
              </span>
            </div>
            <input type="text" class="form-control" id="user" name="categorie" placeholder="Cerca" [(ngModel)]="filter.cerca" />
          </div>
      </div>

      <div class="col-lg-3" *ngIf="mansioni?.length">
        <div class="input-group flex-grow-1">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: transparent;">
              {{'cliente.mansione' | translate}}
            </span>
          </div>
          <ng-multiselect-dropdown [settings]="DropSettings('denominazione')" [placeholder]="'Seleziona'" [data]="mansioni"
            [(ngModel)]="filter.mansioni" ></ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-lg-3" *ngIf="environment.ClientiAddOn['sediReferente'] && sedi?.length">
        <div class="input-group flex-grow-1">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: transparent;">
              {{'cliente.sezioni.sedi' | translate}}
            </span>
          </div>
          <ng-multiselect-dropdown [settings]="DropSettings('fullAddress')" [placeholder]="'Seleziona'" [data]="sedi"
            [(ngModel)]="filter.sedi"></ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-lg-3" *ngIf="environment.ClientiAddOn['repartoReferente'] && reparti?.length && !HideReparti">
        <div class="input-group flex-grow-1">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: transparent;">
              {{'cliente.reparto' | translate}}
            </span>
          </div>
      
          <ng-multiselect-dropdown [settings]="DropSettings()" [placeholder]="'Seleziona'" [data]="reparti"
            [(ngModel)]="filter.reparti" ></ng-multiselect-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="card pt-0">
  <div class="card-body pt-0">
    <div class="table-responsive" style="overflow: scroll; max-height: calc(100vh - 17rem);" >
      <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <thead>
        <tr>
          <th scope="col"  *ngIf=" environment.ClientiAddOn['InvioCredReferenti']" class="align-middle" >
            <input type="checkbox" *ngIf=" environment.ClientiAddOn['InvioCredReferenti']" [(ngModel)]="SelectAll" name="list_name" value="h1" (change)="checkUncheckAll()" />
          </th>
          <th scope="col">{{'cliente.nome' | translate}}</th>
          <th scope="col">{{'cliente.cognome' | translate}}</th>
          <th scope="col" *ngIf="environment.ClientiAddOn['indirizzoReferente']">{{'cliente.indirizzo' | translate}}</th>
          <th scope="col" *ngIf="environment.ClientiAddOn['indirizzoReferente']">{{'cliente.cap' | translate}}</th>
          <th scope="col" *ngIf="environment.ClientiAddOn['indirizzoReferente']">{{'cliente.citta' | translate}}</th>
          <th scope="col" *ngIf="environment.ClientiAddOn['indirizzoReferente']">{{'cliente.provincia' | translate}}</th>
          <th scope="col">{{'cliente.telefono' | translate}}</th>
          <th scope="col">{{'cliente.email' | translate}}</th>
          <th scope="col" *ngIf="environment.ClientiAddOn['relazioniReferenti']">{{'cliente.relation' | translate}}</th>
          <!--<th scope="col">{{'cliente.ruolo' | translate}}</th>-->
          <th scope="col" *ngIf="environment.ClientiAddOn['repartoReferente']  && !HideReparti">{{'cliente.reparto' | translate}}</th>
          <th scope="col" *ngIf="environment.Modules['mansioni']">{{'cliente.mansione' | translate}}</th>
          <th scope="col">{{'cliente.Actions' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of Lista | PipeReferenti: filter" >
          <td *ngIf=" environment.ClientiAddOn['InvioCredReferenti']" class="align-middle"  >
            <input type="checkbox" [(ngModel)]="item.isSelected" name="list_name"
                   (change)="isAllSelected()" />
          </td>
          <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.nome }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.nome" placeholder="{{'cliente.nome' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.cognome }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.cognome" placeholder="{{'cliente.cognome' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" *ngIf="environment.ClientiAddOn['indirizzoReferente']">
            <span *ngIf="!item.InModifica">
              {{ item.indirizzo }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.indirizzo" placeholder="{{'cliente.indirizzo' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" *ngIf="environment.ClientiAddOn['indirizzoReferente']">
            <span *ngIf="!item.InModifica">
              {{ item.cap }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.cap" placeholder="{{'cliente.cap' | translate}}" type="text" name="nome"
                class="form-control">
            </span>
          </td>
          <td class="align-middle" *ngIf="environment.ClientiAddOn['indirizzoReferente']">
            <span *ngIf="!item.InModifica">
              {{ item.citta }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.citta" placeholder="{{'cliente.citta' | translate}}" type="text" name="nome"
                class="form-control">
            </span>
          </td>
          <td class="align-middle" *ngIf="environment.ClientiAddOn['indirizzoReferente']">
            <span *ngIf="!item.InModifica">
              {{ item.provincia }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.provincia" placeholder="{{'cliente.provincia' | translate}}" type="text" name="nome"
                class="form-control">
            </span>
          </td>
          <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.telefono }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.telefono" placeholder="{{'cliente.telefono' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.email }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.email" placeholder="{{'cliente.email' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>
          <td class="align-middle" *ngIf="environment.ClientiAddOn['relazioniReferenti']">
            {{Relation(item)}}
          </td>
          <td class="align-middle" style="min-width: 250px;" *ngIf="environment.ClientiAddOn['repartoReferente'] && !HideReparti">
            <span *ngIf="!item.InModifica">
              {{ item.repartoObject?.label }}
            </span>
            <span *ngIf="item.InModifica" style="min-width: 200px">
                    <ng-multiselect-dropdown [settings]="dropSetting" [placeholder]="'Seleziona'" [data]="reparti" [(ngModel)]="item.repartoObject">
                    </ng-multiselect-dropdown>
            </span>
          </td>
          <td class="align-middle" style="min-width: 250px;" *ngIf="environment.Modules['mansioni']">
            <ng-container *ngIf="!item.InModifica">
              <span *ngFor="let mansione of item?.mansioniObject">
                {{ mansione?.denominazione ?? mansione.mansioneObject?.label }}
              </span>
            </ng-container>
            
            <span *ngIf="item.InModifica" style="min-width: 200px">
              <ng-multiselect-dropdown [settings]="dropMansioneSetting" [placeholder]="'Seleziona'" [data]="mansioni"
                [(ngModel)]="item.mansioniObject">
              </ng-multiselect-dropdown>
            </span>
          </td>
         <!-- <td class="align-middle" >
            <span *ngIf="!item.InModifica">
              {{ item.note }}
            </span>
            <span *ngIf="item.InModifica">
              <input [(ngModel)]="item.note" placeholder="{{'cliente.ruolo' | translate}}" type="text" name="nome" class="form-control">
            </span>
          </td>-->
          <td class="align-middle" >
            <a href="javascript:void(0)" *ngIf="!item.InModifica && environment['Personale']['RefTabs'] && item.id"
              [ngbTooltip]="'Apri il Dettaglio'"
              class="link font-16 text-info font-medium mr-2" (click)='open(item)'>
              <i class="fas fa-eye"></i>
            </a>
            <a href="javascript:void(0)" *ngIf="(!item.InModifica || Cliente )&& !environment.ClientiAddOn['referentiFromPersone']" [ngbTooltip]="item.InModifica? translate.instant('cliente.save'): translate.instant('cliente.edit')" class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
              <i-feather [name]="!item.InModifica? 'edit-3': 'check'" class="feather-sm"></i-feather>
            </a>
            <a href="javascript:void(0)" [ngbTooltip]="item.InModifica? translate.instant('cliente.cancel'): translate.instant('cliente.delete')"
               class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
              <i *ngIf="item.InModifica" class="fas fas fa-times"></i>
              <i-feather *ngIf="!item.InModifica" name="trash-2" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="environment.Modules['FabbisognoFormativo'] && item.id" [ngbTooltip]="'Genera ' + translate.instant('Training')" class="link font-16 text-info font-weight-bold" (click)='AggiungiFabbisogno(item.id)'>
              <i class="fas fa-hands-helping font-14 mr-1 text-info"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

